import { PermissionBubble } from "./PermissionBubble";

export default PermissionBubble;
